var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner",class:{ center: this.center }},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":_vm.color,"size":_vm.getSize,"width":_vm.getSize / 15}}),(_vm.text)?_c('div',{staticClass:"spinner-text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }